import React, { Fragment } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import EarningsDashboard from "../../Feature/deliveryPartner/earningsDashboard";
import AvailabilityCalendar from "../../Feature/deliveryPartner/availabilityCalendar";
import TaskHistory from "../../Feature/deliveryPartner/taskHistory";
import TaxSummary from "../../Feature/deliveryPartner/taxSummary";
import VehicleProfile from "../../Feature/deliveryPartner/vehicleProfile";
import Sidebar from "../../layout/Sidebar";
import DeliveryProfile from "../../Feature/deliveryPartner/profile";
import Notification from "../../Feature/deliveryPartner/notification";

const DeliveryAuth = () => {

  const location = useLocation();
  const isSidebarOpen = useSelector((state) => state.layout.isSidebarOpen);

  return (
    <Fragment>
      <Sidebar />
      <main
        className={` h-[calc(100vh-80px)] pt-[90px] transition-all duration-300  bg-[var(--scondary-bg-color)]  ${isSidebarOpen ? 'ml-64' : 'ml-20'
          }`}
      >
        <div >
          <Routes >
            {/* <Route path="/job-assignment" element={<JobDashboard />} exact></Route> */}
            {/* <Route path="/job-detail" element={<JobDetail />} exact></Route> */}
            {/* <Route path="/status-tracking" element={<StatusUpdate />} exact></Route> */}
            <Route path="/earnings-dashboard" element={<EarningsDashboard />} exact></Route>
            {/* <Route path="/report-issue" element={<ReportIssue />} exact></Route> */}
            <Route path="/availability-calendar" element={<AvailabilityCalendar />} exact></Route>
            {/* <Route path="/feedback" element={<FeedbackView />} exact></Route> */}
            <Route path="/task-history" element={<TaskHistory />} exact></Route>
            {/* <Route path="/app-settings" element={<AppSettings />} exact></Route> */}
            {/* <Route path="/shift-summary-prompt" element={<ShiftSummaryPrompt />} exact></Route> */}
            {/* <Route path="/broadcast-inbox" element={<BroadcastInbox />} exact></Route> */}
            {/* <Route path="/dynamic-route-alert" element={<DynamicRouteAlert />} exact></Route> */}
            {/* <Route path="/active-deliveries" element={<ActiveDeliveries />} exact></Route> */}
            {/* <Route path="/start-shift-checklist" element={<StartShiftChecklist />} exact></Route> */}
            <Route path="/tax-summary" element={<TaxSummary />} exact></Route>
            <Route path="/vehical-profile" element={<VehicleProfile />} exact></Route>
            <Route path="/profile" element={<DeliveryProfile />} exact></Route>
            <Route path="/notification" element={<Notification />} />
            
          </Routes>

        </div>
      </main>
    </Fragment>
  );
};

export default DeliveryAuth;
